export class PlanCompensatorioTurnosModel {
    idTurno: number;
    nombre: string;
    fechaInicial: Date;
    fechaFinal: Date;
    estado: string;
    idPlanCompensacion: number;
}
